import { render, staticRenderFns } from "./BlockTimestampAggregationsChart.vue?vue&type=template&id=4b8ea3be&"
import script from "./BlockTimestampAggregationsChart.vue?vue&type=script&lang=js&"
export * from "./BlockTimestampAggregationsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports